import { gql } from '@apollo/client';

const TaxjarCategoryInfo = gql`
  fragment TaxjarCategoryInfo on TaxjarCategory {
    id
    active
    description
    firstSeenAt
    lastChangedAt
    lastSeenAt
    name
    productTaxCode
    syncedAt
  }
`;

export default TaxjarCategoryInfo;
